import { sortList } from "."


interface OrderByProps {
  orderBy: string
  setOrderBy: (orderBy: string) => void
}

const OrderBy = (props: OrderByProps) => {

  return (
    <div className="flex space-x-2 items-center">
      {sortList.map((sort, index) => (
        <button
          key={index}
          className={`text-xs font-poppins py-1 px-4 rounded text-center ${props.orderBy === sort.value ? "bg-mooimom text-white font-semibold" : "bg-white border border-reviewBg border-solid text-black"}`}
          onClick={() => props.setOrderBy(sort.value)}
        >
          {sort.name}
        </button>
      ))}
    </div>
  )
}

export default OrderBy
